var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturnTripDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 38,
    viewBox: "0 0 32 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10252_73524)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10252_73524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9143 12.7618L20.7034 12.7618L13.3359 21.5766L8.66927 21.5766C8.05043 21.5766 7.45694 21.8088 7.01936 22.2221C6.58177 22.6353 6.33594 23.1959 6.33594 23.7803C6.33594 24.3648 6.58177 24.9253 7.01935 25.3386C7.45694 25.7518 8.05043 25.984 8.66927 25.984L13.4584 25.984L20.8259 34.7988L22.9131 34.7988L19.6348 25.984L25.0026 25.984L27.3359 29.2896L29.6693 29.2896L27.3359 23.7803L29.6693 18.2711L27.3359 18.2711L25.0026 21.5766L19.5368 21.5766L22.9143 12.7618Z",
    fill: "#333333"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10252_73524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.7537 33.039L8.96453 33.039L16.332 24.2242L20.9987 24.2242C21.6175 24.2242 22.211 23.992 22.6486 23.5787C23.0862 23.1655 23.332 22.6049 23.332 22.0205C23.332 21.436 23.0862 20.8755 22.6486 20.4622C22.211 20.0489 21.6175 19.8168 20.9987 19.8168L16.2095 19.8168L8.84203 11.002L6.75487 11.002L10.0332 19.8168L4.66536 19.8168L2.33203 16.5112L-0.00130105 16.5112L2.33203 22.0205L-0.00130153 27.5297L2.33203 27.5297L4.66536 24.2242L10.1312 24.2242L6.7537 33.039Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10252_73524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 28,
    fill: "white",
    transform: "translate(4 37.002) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10252_73524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.037,
    height: 23.3333,
    fill: "white",
    transform: "translate(6.33594 34.7988) rotate(-90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10252_73524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.037,
    height: 23.3333,
    fill: "white",
    transform: "translate(0 22.0371) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnTripDark);
export default __webpack_public_path__ + "static/media/return-trip-dark.d0380c029ca7fce34310f6ec8daf9b55.svg";
export { ForwardRef as ReactComponent };